import { phoneNumbers } from "./phoneNumbers";

export const genericErrorMessage = `Something went wrong. Please try again or call ${phoneNumbers.auto} for assistance.`;
